import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import * as actions from '../../actions'
import LogIn from './LogIn'

const AuthModal = ({
  auth,
  handleAuthModal,
  logIn,
  handleLocalLogin,
  continueSignUp,
  signUpBack,
  handleSignUp
}) => (
  <ModalDiv>
    <Background onClick={() => handleAuthModal(false)} />
    <Container>
      <LogIn
        auth={auth}
        isLogIn={auth.isLogIn}
        handleAuthModal={handleAuthModal}
        logIn={logIn}
        handleLocalLogin={handleLocalLogin}
        continueSignUp={continueSignUp}
        signUpBack={signUpBack}
        handleSignUp={handleSignUp}
      />
    </Container>
  </ModalDiv>
)

AuthModal.propTypes = {
  auth: PropTypes.objectOf(PropTypes.any).isRequired,
  handleAuthModal: PropTypes.func.isRequired,
  logIn: PropTypes.func.isRequired,
  handleLocalLogin: PropTypes.func.isRequired,
  continueSignUp: PropTypes.func.isRequired,
  signUpBack: PropTypes.func.isRequired,
  handleSignUp: PropTypes.func.isRequired
}

const mapStateToProps = (state) => ({
  auth: state.auth.status
})

const mapDispatchToProps = (dispatch) => ({
  handleAuthModal: (bool, isLogIn = false) => {
    dispatch({
      type: actions.HANDLE_AUTH_MODAL,
      value: bool
    })
    dispatch({
      type: actions.IS_LOG_IN,
      value: isLogIn
    })
  },
  logIn: ({ loginData }) => {
    dispatch(actions.logIn({ loginData }))
  },
  handleLocalLogin: ({ email, password }) => {
    dispatch(actions.handleLocalLogin({ email, password }))
  },
  continueSignUp: () => {
    dispatch({ type: actions.CONTINUE_SIGN_UP })
  },
  signUpBack: () => {
    dispatch({ type: actions.SIGN_UP_BACK })
  },
  handleSignUp: ({ user }) => {
    dispatch(actions.handleSignUp({ user }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(AuthModal)

const ModalDiv = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1100;
  overflow-y: auto;
`

const Background = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 60;
  background-color: rgba(0, 0, 0, 0.7);
`

const Container = styled.div`
  width: 90vw;
  max-width: 480px;
  max-height: 80vh;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  z-index: 70;
`
